import React from 'react';

import Box from '@mui/material/Box';
import _, { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import moment from 'moment-timezone';
import { withRouter } from 'providers';
import Rating from 'react-rating';

import styles, * as E from './styles';

class DriverProfileInformation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      driverInfo: null,
      unsubscribed: false,
    };
  }

  componentDidMount() {
    const { driver, driverStore } = this.props;
    if (_.has(driver, 'id')) {
      driverStore.checkUnsubscribed(driver.id, (res) => this.setState({ unsubscribed: res.data.unsubscribed }));
    }
  }

  render() {
    const { driver } = this.props;

    if (!driver) return <div>Loading...</div>;

    return (
      <E.Container>
        <Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flexGrow: 0, flexShrink: 0, flexBasis: 'auto' }}>
              <E.DriverInfoContainer>
                <E.DriverAvatar>
                  <E.Avatar src={driver.photo} />
                </E.DriverAvatar>
                <E.DriverSince>{`Driver since: ${driver.background_decision_ts ? moment(driver.background_decision_ts).format('MM/DD/YYYY') : ''}`}</E.DriverSince>
              </E.DriverInfoContainer>
            </Box>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ flex: 1 }}>
                  <E.DriverNameContainer>
                    <E.DriverName>{`${_.get(driver, 'first_name', '')} ${_.get(driver, 'last_name', '')}`}</E.DriverName>
                    <E.DriverId>{`#${driver.id}`}</E.DriverId>
                    {/*<E.DriverRegion>{`SFO`}</E.DriverRegion>*/}
                  </E.DriverNameContainer>
                </Box>
                <Box sx={{ flexGrow: 0, flexShrink: 0, flexBasis: 'auto' }}>
                  <E.LabelStatus>
                    {`Status: `}
                    <E.Status>{driver.status}</E.Status>
                  </E.LabelStatus>
                </Box>
              </Box>
              <E.RatingContainer>
                <Rating
                  readonly={true}
                  initialRating={Math.round(driver.driverScore)}
                  emptySymbol={<img src="/assets/images/star-2.png" />}
                  fullSymbol={<img src="/assets/images/star-3.png" />}
                />
              </E.RatingContainer>
              <Box sx={{ display: 'flex', ...styles.driverRow }}>
                <Box sx={{ flex: 1 }}>
                  <E.DriverLabel>{`Phone Number`}</E.DriverLabel>
                  <E.Text1>{driver.phone_number}</E.Text1>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <E.DriverLabel>{`E-mail`}</E.DriverLabel>
                  <E.Text1>{driver.email}</E.Text1>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <E.DriverLabel>{`Zipcode`}</E.DriverLabel>
                  <E.Text1>{_.get(driver, 'home_address.zipcode', '_')}</E.Text1>
                </Box>
              </Box>
              <Box sx={{ display: 'flex', ...styles.driverRow }}>
                <Box sx={{ flex: 1 }}>
                  <E.DriverLabel>{`Vehicle Info`}</E.DriverLabel>
                  <E.Text1>{`${_.defaultTo(driver.vehicle_color, '')} ${_.defaultTo(driver.vehicle_make, '')} ${_.defaultTo(driver.vehicle_model, '')}`}</E.Text1>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <E.DriverLabel>{`License Plate`}</E.DriverLabel>
                  <E.Text1>{`${driver.vehicle_license_plate_state ? driver.vehicle_license_plate_state + ' - ' : ''}${driver.vehicle_license_plate ? driver.vehicle_license_plate : ''}`}</E.Text1>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <E.DriverLabel>{`Drivers License`}</E.DriverLabel>
                  <E.Text1>{driver.driver_license}</E.Text1>
                </Box>
              </Box>
              <Box sx={{ display: 'flex' }}>
                <Box sx={{ flex: 1 }}>
                  <E.DriverLabel>{`SMS Unsubscribed`}</E.DriverLabel>
                  <E.Text1>{this.state.unsubscribed ? 'YES' : 'NO'}</E.Text1>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <E.DriverLabel>{`Couriers`}</E.DriverLabel>
                  <E.Text1>{(driver?.couriers && driver.couriers.map((c) => c.company).join()) || 'N/A'}</E.Text1>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <E.DriverLabel>{`Regions`}</E.DriverLabel>
                  <E.Text1>{(driver?.regions && driver.regions.join()) || 'N/A'}</E.Text1>
                </Box>
              </Box>
            </Box>
          </Box>
          <E.RatingContainer></E.RatingContainer>
        </Box>
      </E.Container>
    );
  }
}
export default compose(withRouter, inject('driverStore'), observer)(DriverProfileInformation);
